import { network } from 'services/network';

export const createUser = (params) => {
    return network.post('admin/bo/createUser', params).then((response) => response.data);
};
